import BaseRequest from './base/BaseRequest';

export default class ServiceRequest extends BaseRequest {

  sendContact(params) {
    let url = '/contact';
    return this.post(url, params);
  }
}